import { omit } from 'lodash';

export const omitRef = (val: Parameters<typeof omit>[0]): ReturnType<typeof omit> =>
    omit(val, 'ref');
